<template>
  <SfIndicatorNew v-if="showNewIndicator" :position="'top-left'" />
</template>

<script lang="ts" setup>
import { onBeforeUnmount, ref } from 'vue'

import SfIndicatorNew from '../../components/sf-indicator/sf-indicator-new.vue'

const showNewIndicator = ref(false)

window.eventHub.$on(
  'drawer:communication:unread-item-count-changed',
  handleItemCountChange
)

onBeforeUnmount(() => {
  window.eventHub.$off(
    'drawer:communication:unread-item-count-changed',
    handleItemCountChange
  )
})

function handleItemCountChange(unreadCount: number) {
  showNewIndicator.value = unreadCount > 0
}
</script>
<style lang="scss">
@import '@app/shared/vue/components/sf-indicator/sf-indicator-new';
</style>
